import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhLocale from './zh' //中文
import enLocale from './en' //英文
import tibetanLocale from './tibetan' //藏文
import {
    getStore
} from '../config/utils'


Vue.use(VueI18n)

const messages = {
    'zh': {
        ...zhLocale,
    },
    'en': {
        ...enLocale,
    },
    'tibet': {
        ...tibetanLocale,
    }
}
const i18n = new VueI18n({
    // set locale
    locale: window.localStorage.getItem('lang') || 'zh',
    fallbackLocale: 'zh', //根据指定的locale没有找到对应的资源的情况下，使用的locale
    // set locale messages
    messages
})

export default i18n